module.exports = __webpack_public_path__ + "static/img/bg.fa4f10cf.png";